import React from 'react';
import { MenuIcon, SearchIcon } from 'lucide-react';
import { BRAND_LOGO } from '../data/offer';
export function SiteHeader() {
  return <header className="sticky top-0 z-30 border-b border-brand-blush bg-paper/95 backdrop-blur" data-id="element-212" data-mp="19uzyoob10jcy">
      <div className="mx-auto flex h-16 max-w-6xl items-center gap-4 px-4 sm:px-6" data-id="element-213" data-mp="1nmen5anpdcre">
        <a href="#top" className="flex items-center gap-2.5" aria-label="Mi Cocina Natural — inicio" data-id="element-214" data-mp="1ip4nl26lnkpu">
          <img src={BRAND_LOGO} alt="" className="h-10 w-10 rounded-md bg-brand-blush object-cover object-top" data-id="element-215" data-mp="uz0l4y55dr0f" />
          <span className="leading-none" data-id="element-216" data-mp="14w5bla6108n1">
            <span className="block whitespace-nowrap font-display text-[1.35rem] font-bold tracking-tight text-brand" data-id="element-217" data-mp="14xzuyk1nfsp0">
              Mi Cocina Natural
            </span>
            <span className="mt-1 block font-sans text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-ink-muted" data-id="element-218" data-mp="2gasl5qesk92y">
              Salud · Nutrición · Bienestar
            </span>
          </span>
        </a>

        <nav aria-label="Secciones" className="ml-auto hidden items-center gap-6 lg:flex" data-id="element-219" data-mp="29isdluxx6lpx">
          {['Nutrición', 'Digestión', 'Recetas', 'Bienestar', 'Investigación'].map(item => <a key={item} href="#top" className="font-sans text-[0.8rem] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-brand" data-id="element-220" data-mp="2jhq8rgpupdhw">
              {item}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-1 lg:ml-0" data-id="element-221" data-mp="1vs5mooyei04e">
          <button type="button" className="flex h-9 w-9 items-center justify-center rounded-sm text-ink-soft transition-colors duration-150 ease-out hover:bg-brand-blush/60 hover:text-ink" aria-label="Buscar" data-id="element-222" data-mp="1vqb2jcuyec1d">
            <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="181rtuw7zrx8r" />
          </button>
          <button type="button" className="flex h-9 w-9 items-center justify-center rounded-sm text-ink-soft transition-colors duration-150 ease-out hover:bg-brand-blush/60 hover:text-ink lg:hidden" aria-label="Abrir menú" data-id="element-224" data-mp="1d1e4qz0cl1ee">
            <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-225" data-mp="100ang2fyujz9" />
          </button>
        </div>
      </div>
    </header>;
}